import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_CS2: unique symbol = symbolName("cs2");
